module.exports = __webpack_public_path__ + "assets/img/monkeytalks-logo.55669b0e6e58d43ee72553cb1536f0bc.svg";